// extracted by mini-css-extract-plugin
export default {"switcher":"Switcher_switcher__+JA-A"};